import React from 'react';
import { JsonYamlConverter } from '../components/json-yaml-converter/JsonYamlConverter';

export const JsonYamlConverterPage: React.FC = () => {
  return (
    <div className="page-container">
      <JsonYamlConverter />
    </div>
  );
};